module.exports = __webpack_public_path__ + "img/no-service.4e40c1f5.png";